import { Routes } from '@angular/router';

import { AuthGuard } from '~app/guards/auth.guard';
import { NavGuard } from '~app/guards/nav.guard';
import { UtService } from '~app/services/ut.service';

import { UtilityFieldOperatorsHandler } from './handlers/utility/field.operators.handler';
import { UtilityOperationHandler } from './handlers/utility/operation.handler';
import { UtilityOperationStepHandler } from './handlers/utility/operation.step.handler';
import { UtilityOrderHandler } from './handlers/utility/order.handler';
import { UtilityTrucksHandler } from './handlers/utility/trucks.handler';
import { Error404Component } from './error/404/404.component';
import { UserLoginComponent } from './user/login/login.component';

export const appRoutes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: '/user/dashboard',
	},
	{
		path: 'user/login',
		component: UserLoginComponent,
		canActivate: [NavGuard],
	},
	{
		path: 'user',
		loadChildren: () => import('./user/user.routes').then(m => m.userRoutes),
		canActivateChild: [NavGuard, AuthGuard],
	},
	{
		path: 'run',
		loadChildren: () => import('./run/run.routes').then(m => m.runRoutes),
		canActivateChild: [NavGuard, AuthGuard],
		providers: [
			UtilityOperationHandler,
			UtService,
			UtilityFieldOperatorsHandler,
			UtilityTrucksHandler,
		],
	},
	{
		path: 'utility',
		loadChildren: () => import('./utility/utility.routes').then(m => m.utilityRoutes),
		canActivateChild: [NavGuard, AuthGuard],
		providers: [
			UtilityOrderHandler,
			UtilityTrucksHandler,
			UtilityOperationHandler,
			UtilityOperationStepHandler,
		],
	},
	{
		path: '**',
		component: Error404Component,
		canActivate: [NavGuard],
	},
];
